window.Dashboard = window.Dashboard || {};
window.Dashboard.helpers = window.Dashboard.helpers || {};

const features = {
    BeHeard: "BeHeard",
    BeHeardGoogleReviews: "BeHeardGoogleReviews",
    SendRequestedTimeIfAsapOrder: "SendRequestedTimeIfAsapOrder",
    UberProofOfDeliveryPinCode: "UberProofOfDeliveryPinCode",
    UberProofOfDeliverySignature: "UberProofOfDeliverySignature",
    UberProofOfDeliverySignatureRelationshipRequired: "UberProofOfDeliverySignatureRelationshipRequired",
    SendCustomerNotificationsWhenOrdersAreCompleted: "SendCustomerNotificationsWhenOrdersAreCompleted",
}

class FeatureHelper {
    fetchSendCustomerNotificationsWhenOrdersAreCompletedFeatureFor(store) {
        return store?.Features?.find(feature => {
            return feature.Name === features.SendCustomerNotificationsWhenOrdersAreCompleted;
        });
    }
}

window.Dashboard.helpers.features = new FeatureHelper();
